export enum AccessUserType {
  Team = "team",
  Person = "person",
}